'use client';

import SvgMyFill from '@common/icon/SvgMyFill';
import SvgShoppingBasketFill from '@common/icon/SvgShoppingBasketFill';
import Link from 'next/link';

import { Image, PageNavigation } from '@/components/client';
import { ROUTES, WEL_MARKET_ROUTES } from '@/constants';

import { useMarketCart } from '../../cart/_hooks/useMarketCart';

export const LocalMarketNav = () => {
  const { totalCount } = useMarketCart();

  return (
    <PageNavigation
      title={
        <Image
          src="/images/local-market/home/logo-welmarket-orange.svg"
          alt="웰마켙"
          width={129}
          height={22}
          unoptimized
        />
      }
    >
      <div className="flex items-center gap-20">
        <Link
          href={WEL_MARKET_ROUTES.CART.pathname}
          aria-label="장바구니"
          className="relative size-26"
        >
          <SvgShoppingBasketFill className="size-24 text-Gray-900" />
          {totalCount > 0 && (
            <span className="absolute -right-6 -top-4 flex size-16 items-center justify-center rounded-pill bg-R-500 font-600 text-Gray-white typo-caption2">
              {totalCount > 99 ? '99+' : totalCount}
            </span>
          )}
        </Link>
        <Link href={ROUTES.MY.pathname} aria-label="마이페이지">
          <SvgMyFill className="size-24 text-Gray-900" />
        </Link>
      </div>
    </PageNavigation>
  );
};
